import { ClaimDirectDepositRequest } from '@bybeam/platform-types';
import Message from '@platform-ui-common/components/Message/index.js';
import TextInput from '@platform-ui-common/components/TextInput/index.js';
import useForm, {
  defaultRequiredErrorMessage,
  requiredField,
} from '@platform-ui-common/hooks/useForm/index.js';
import ClaimRoutes from '@platform-ui/claim/ClaimRoutes.js';
import ClaimForm from '@platform-ui/claim/components/ClaimForm/index.js';
import useClaim from '@platform-ui/claim/hooks/useClaim.js';
import { makeRoute } from '@platform-ui/utilities/Routes.js';
import isRoutingNumberValid from '@platform-ui/utilities/routingNumber.js';
import { useHistory } from 'react-router';

function RoutingNumber(): JSX.Element {
  const { fulfillmentId, payload, setPayload } = useClaim<ClaimDirectDepositRequest>();
  const history = useHistory();

  const { formData, dispatch, errors, trySubmit } = useForm(
    { routingNumber: payload?.bankAccount?.routingNumber ?? '' },
    {
      routingNumber: requiredField(
        ({ routingNumber }) => isRoutingNumberValid(routingNumber),
        defaultRequiredErrorMessage('Routing Number'),
      ),
    },
  );

  const onSubmit = (): void =>
    trySubmit(() => {
      setPayload({
        ...payload,
        bankAccount: { ...payload?.bankAccount, routingNumber: formData.routingNumber },
      });
      history.push(makeRoute(ClaimRoutes.ACH_ACCOUNT_TYPE, { fulfillmentId }));
    });
  const errorMessages = Object.values(errors).flat();

  return (
    <ClaimForm
      header="Enter your routing number"
      subHeader="Please check that your routing number matches the nine-digit number provided by your bank."
      helperText={
        <Message variant="info">
          Entering an incorrect routing number will prevent funds from transferring to your account.
        </Message>
      }
      onSubmit={onSubmit}
      errors={errorMessages}
    >
      <TextInput
        id="routing-number"
        label="Routing Number"
        value={formData.routingNumber}
        onChange={(value): void =>
          dispatch({ type: 'simpleUpdate', payload: { field: 'routingNumber', value } })
        }
        error={!!errors?.routingNumber}
      />
    </ClaimForm>
  );
}

export default RoutingNumber;
